/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./product-config.vue?vue&type=template&id=65ea4240&"
import script from "./product-config.vue?vue&type=script&lang=js&"
export * from "./product-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports